import * as React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { createOpening, getTodayOpening, clearOpening } from '../../features/opening/openingSlice'
import { getCashCounterList } from '../../features/setup/useableSlice'
import { getAllUsers } from '../../features/auth/authSlice'
import Navbar from '../setup/Navbar'
import HeadingTest from '../../BuiltInComponent/HeadingTest'
import { Box, Container, Grid2, TextField, Typography, Alert, Autocomplete } from '@mui/material'
import ButtonNormal from '../../BuiltInComponent/ButtonNormal'
import AutoComplete from '../../BuiltInComponent/AutoComplete'
import Loading from '../../BuiltInComponent/Loading'
import dayjs from 'dayjs'
import { useNavigate } from 'react-router-dom'

export default function DailyOpening() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { user, allUsers } = useSelector(state => state.auth)
  const { data: openingData, loading, success, error } = useSelector(state => state.opening)
  const { cashCounters } = useSelector(state => state.ru)
  const [loadingStatus, setLoadingStatus] = React.useState('none')

  React.useEffect(() => {
    const userBranch = user?.branchID || user?.defaultBranchID || 1
    dispatch(getAllUsers({ cmpID: user?.cmpID, branchID: userBranch }))
    // Check if already opened today
    if (user?.userID) {
      dispatch(getTodayOpening({ userID: user.userID }))
    }
  }, [dispatch, user?.cmpID, user?.branchID, user?.defaultBranchID, user?.userID])

  const [openingAmount, setOpeningAmount] = React.useState(0)
  const [selectedBranch, setSelectedBranch] = React.useState(user?.branchID || 1)
  const [selectedUser, setSelectedUser] = React.useState(user?.userID || '')
  const [dailyOpeningData, setDailyOpeningData] = React.useState({
    userID: '',
    branchID: selectedBranch,
    tillID: '',
    openingAmount: 0,
    denomination_5000: 0,
    denomination_1000: 0,
    denomination_500: 0,
    denomination_100: 0,
    denomination_50: 0,
    denomination_20: 0,
    denomination_10: 0,
    denomination_5_coin: 0,
    denomination_2_coin: 0,
    denomination_1_coin: 0,
    remarks: 'Opening'
  })

  const [isVisible, setIsVisible] = React.useState(true)

  React.useEffect(() => {
    const blinkInterval = setInterval(() => {
      setIsVisible((prev) => !prev)
    }, 500)
    return () => clearInterval(blinkInterval)
  }, [])

  // Fetch cash counters for selected branch
  React.useEffect(() => {
    if (selectedBranch) {
      dispatch(getCashCounterList(selectedBranch))
    }
  }, [selectedBranch, dispatch])

  // Calculate total opening amount from denominations
  React.useEffect(() => {
    const total = (parseInt(dailyOpeningData.denomination_5000) || 0) * 5000 +
      (parseInt(dailyOpeningData.denomination_1000) || 0) * 1000 +
      (parseInt(dailyOpeningData.denomination_500) || 0) * 500 +
      (parseInt(dailyOpeningData.denomination_100) || 0) * 100 +
      (parseInt(dailyOpeningData.denomination_50) || 0) * 50 +
      (parseInt(dailyOpeningData.denomination_20) || 0) * 20 +
      (parseInt(dailyOpeningData.denomination_10) || 0) * 10 +
      (parseInt(dailyOpeningData.denomination_5_coin) || 0) * 5 +
      (parseInt(dailyOpeningData.denomination_2_coin) || 0) * 2 +
      (parseInt(dailyOpeningData.denomination_1_coin) || 0) * 1

    setOpeningAmount(total)
    setDailyOpeningData(prev => ({
      ...prev,
      openingAmount: total
    }))
  }, [dailyOpeningData.denomination_5000, dailyOpeningData.denomination_1000, dailyOpeningData.denomination_500, dailyOpeningData.denomination_100, dailyOpeningData.denomination_50, dailyOpeningData.denomination_20, dailyOpeningData.denomination_10, dailyOpeningData.denomination_5_coin, dailyOpeningData.denomination_2_coin, dailyOpeningData.denomination_1_coin])

  const handleChange = (e) => {
    const { name, value } = e.target
    setDailyOpeningData(prev => ({
      ...prev,
      [name]: name === 'remarks' ? value : parseInt(value) || 0
    }))
  }

  const onChangeTills = (data) => {
    if (data && data.tillID) {
      setDailyOpeningData(prev => ({
        ...prev,
        tillID: data.tillID
      }))
    }
  }

  const onChangeUsers = (data) => {
    if (data && data.userID) {
      setSelectedUser(data.userID)
      setDailyOpeningData(prev => ({
        ...prev,
        userID: data.userID
      }))
      // Check if this user already has an opening today
      dispatch(getTodayOpening({ userID: data.userID }))
    }
  }

  const onChangeUser = (data) => {
    if (data && data.userID) {
      setSelectedUser(data.userID)
      setDailyOpeningData(prev => ({
        ...prev,
        userID: data.userID,
        branchID: data.branchID || selectedBranch
      }))
      dispatch(getTodayOpening({ userID: data.userID }))
    }
  }

  const addOpening = () => {
    if (!dailyOpeningData.userID || !dailyOpeningData.tillID) {
      alert('Please select User and Cash Counter')
      return
    }

    setLoadingStatus('')
    dispatch(createOpening({
      userID: dailyOpeningData.userID,
      branchID: dailyOpeningData.branchID,
      tillID: dailyOpeningData.tillID,
      openingAmount,
      denomination_5000: dailyOpeningData.denomination_5000,
      denomination_1000: dailyOpeningData.denomination_1000,
      denomination_500: dailyOpeningData.denomination_500,
      denomination_100: dailyOpeningData.denomination_100,
      denomination_50: dailyOpeningData.denomination_50,
      denomination_20: dailyOpeningData.denomination_20,
      denomination_10: dailyOpeningData.denomination_10,
      denomination_5_coin: dailyOpeningData.denomination_5_coin,
      denomination_2_coin: dailyOpeningData.denomination_2_coin,
      denomination_1_coin: dailyOpeningData.denomination_1_coin,
      remarks: dailyOpeningData.remarks
    }))
      .then((result) => {
        if (result.payload?.openingID) {
          setTimeout(() => {
            setLoadingStatus('none')
            navigate('/POS')
          }, 1500)
        }
      })
      .catch((err) => {
        setLoadingStatus('none')
        console.error('Opening error:', err)
      })
  }

  return (
    <>
      <Navbar />
      <Container>
        <Grid2 container spacing={2}>
          <Grid2 size={{ xs: 12, md: 4 }}></Grid2>
          <Grid2 size={{ xs: 12, md: 4 }}>
            <ButtonNormal
              onClick={() => {
                dispatch(clearOpening())
                setDailyOpeningData({
                  userID: '',
                  branchID: selectedBranch,
                  tillID: '',
                  openingAmount: 0,
                  denomination_5000: 0,
                  denomination_1000: 0,
                  denomination_500: 0,
                  denomination_100: 0,
                  denomination_50: 0,
                  denomination_20: 0,
                  denomination_10: 0,
                  denomination_5_coin: 0,
                  denomination_2_coin: 0,
                  denomination_1_coin: 0,
                  remarks: 'Opening'
                })
              }}
              text='Change User'
            />
          </Grid2>
          <Grid2 size={{ xs: 12, md: 4 }}></Grid2>
        </Grid2>
        <HeadingTest text='Daily Opening' />

        {/* Show if opening already exists */}
        {openingData && openingData.openingID ? (
          <Box sx={{ mt: 5, textAlign: 'center' }}>
            <Alert severity="info" sx={{ mb: 3 }}>
              <Typography variant='h5'>Opening already found with selected user!</Typography>
              <Typography variant='body1'>سیلیکٹ کیے ہوئے صارف کی ایک اوپنینگ پہلے سے موجود ہے</Typography>
            </Alert>
            <Typography variant='h6' sx={{ visibility: isVisible ? 'visible' : 'hidden' }}>
              Opened Date: {dayjs(openingData.openingDate).format('DD-MMM-YYYY')} <br />
              Opening Amount: {openingData.openingAmount} <br />
              Cash Counter: {openingData.tillID}
            </Typography>
          </Box>
        ) : (
          <Grid2 container spacing={2} sx={{ mt: 2 }}>
            {/* User Selection */}
            <Grid2 size={{ xs: 12, md: 4 }}>
              <Autocomplete
                options={allUsers || []}
                getOptionLabel={(option) => option?.userName ? `${option.userName} (ID: ${option.userID})` : `ID: ${option?.userID || ''}`}
                value={allUsers?.find((c) => c.userID === dailyOpeningData.userID) || null}
                onChange={(event, newValue) => {
                  if (newValue && newValue.userID) {
                    const userBranch = newValue.branchID || user?.branchID || 1
                    setSelectedUser(newValue.userID)
                    setSelectedBranch(userBranch)
                    setDailyOpeningData(prev => ({
                      ...prev,
                      userID: newValue.userID,
                      branchID: userBranch,
                      tillID: ''
                    }))
                    dispatch(getTodayOpening({ userID: newValue.userID }))
                  }
                }}
                renderInput={(params) => <TextField {...params} label='Select User' size='small' />}
                size='small'
                isOptionEqualToValue={(option, value) => option?.userID === value?.userID}
              />
            </Grid2>

            <Grid2 size={{ xs: 12, md: 3 }}>
              <Autocomplete
                options={cashCounters || []}
                getOptionLabel={(option) => option?.counterName ? `${option.counterName} (ID: ${option.counterID})` : `ID: ${option?.counterID || ''}`}
                value={cashCounters?.find((c) => c.counterID === dailyOpeningData.tillID) || null}
                onChange={(event, newValue) => {
                  if (newValue && newValue.counterID) {
                    setDailyOpeningData(prev => ({
                      ...prev,
                      tillID: newValue.counterID
                    }))
                  }
                }}
                renderInput={(params) => <TextField {...params} label='Select Cash Counter' size='small' />}
                size='small'
                isOptionEqualToValue={(option, value) => option?.counterID === value?.counterID}
              />
            </Grid2>

            {/* Denomination Input Fields */}
            <Grid2 size={{ xs: 6, md: 1.5 }}>
              <TextField
                id="denomination_5000"
                label="5000"
                variant="outlined"
                fullWidth
                name="denomination_5000"
                onChange={handleChange}
                size='small'
                value={dailyOpeningData.denomination_5000}
                type="number"
              />
            </Grid2>
            <Grid2 size={{ xs: 6, md: 1.5 }}>
              <TextField
                id="denomination_1000"
                label="1000"
                variant="outlined"
                fullWidth
                name="denomination_1000"
                onChange={handleChange}
                size='small'
                value={dailyOpeningData.denomination_1000}
                type="number"
              />
            </Grid2>
            <Grid2 size={{ xs: 6, md: 1.5 }}>
              <TextField
                id="denomination_500"
                label="500"
                variant="outlined"
                fullWidth
                name="denomination_500"
                onChange={handleChange}
                size='small'
                value={dailyOpeningData.denomination_500}
                type="number"
              />
            </Grid2>
            <Grid2 size={{ xs: 6, md: 1.5 }}>
              <TextField
                id="denomination_100"
                label="100"
                variant="outlined"
                fullWidth
                name="denomination_100"
                onChange={handleChange}
                size='small'
                value={dailyOpeningData.denomination_100}
                type="number"
              />
            </Grid2>
            <Grid2 size={{ xs: 6, md: 1.5 }}>
              <TextField
                id="denomination_50"
                label="50"
                variant="outlined"
                fullWidth
                name="denomination_50"
                onChange={handleChange}
                size='small'
                value={dailyOpeningData.denomination_50}
                type="number"
              />
            </Grid2>
            <Grid2 size={{ xs: 6, md: 1.5 }}>
              <TextField
                id="denomination_20"
                label="20"
                variant="outlined"
                fullWidth
                name="denomination_20"
                onChange={handleChange}
                size='small'
                value={dailyOpeningData.denomination_20}
                type="number"
              />
            </Grid2>
            <Grid2 size={{ xs: 6, md: 1.5 }}>
              <TextField
                id="denomination_10"
                label="10"
                variant="outlined"
                fullWidth
                name="denomination_10"
                onChange={handleChange}
                size='small'
                value={dailyOpeningData.denomination_10}
                type="number"
              />
            </Grid2>
            <Grid2 size={{ xs: 6, md: 1.5 }}>
              <TextField
                id="denomination_5_coin"
                label="5 (Coin)"
                variant="outlined"
                fullWidth
                name="denomination_5_coin"
                onChange={handleChange}
                size='small'
                value={dailyOpeningData.denomination_5_coin}
                type="number"
              />
            </Grid2>
            <Grid2 size={{ xs: 6, md: 1.5 }}>
              <TextField
                id="denomination_2_coin"
                label="2 (Coin)"
                variant="outlined"
                fullWidth
                name="denomination_2_coin"
                onChange={handleChange}
                size='small'
                value={dailyOpeningData.denomination_2_coin}
                type="number"
              />
            </Grid2>
            <Grid2 size={{ xs: 6, md: 1.5 }}>
              <TextField
                id="denomination_1_coin"
                label="1 (Coin)"
                variant="outlined"
                fullWidth
                name="denomination_1_coin"
                onChange={handleChange}
                size='small'
                value={dailyOpeningData.denomination_1_coin}
                type="number"
              />
            </Grid2>
            <Grid2 size={{ xs: 6, md: 1.5 }}>
              <TextField
                id="openingAmount"
                label="Opening Amount"
                variant="outlined"
                fullWidth
                name="openingAmount"
                disabled
                size='small'
                value={openingAmount}
                type="number"
              />
            </Grid2>

            {/* Remarks Field */}
            <Grid2 size={{ xs: 12 }}>
              <TextField
                id="remarks"
                label="Remarks (Optional)"
                variant="outlined"
                fullWidth
                name="remarks"
                onChange={handleChange}
                size='small'
                value={dailyOpeningData.remarks}
                multiline
                rows={2}
              />
            </Grid2>

            {/* Error/Success Messages */}
            {error && (
              <Grid2 size={{ xs: 12 }}>
                <Alert severity="error">{error.message || 'Error creating opening'}</Alert>
              </Grid2>
            )}
            {success && (
              <Grid2 size={{ xs: 12 }}>
                <Alert severity="success">Opening created successfully!</Alert>
              </Grid2>
            )}

            {/* Action Button */}
            <Grid2 size={{ xs: 12, md: 2 }}>
              <ButtonNormal text='Open Cash Counter' onClick={addOpening} disabled={loading} />
            </Grid2>
          </Grid2>
        )}

        {/* Loading Indicator */}
        <Box sx={{ display: loadingStatus }}>
          <Loading text={'Saving Opening'} />
        </Box>
      </Container>
    </>
  )
}